export const suffixOptions = [
  {
    suffixId: '1',
    suffix: 'Dr',
    suffixTitle: 'Dr',
  },
  {
    suffixId: '2',
    suffix: 'Estate of',
    suffixTitle: 'Estate of',
  },
  {
    suffixId: '3',
    suffix: 'Miss',
    suffixTitle: 'Miss',
  },
  {
    suffixId: '4',
    suffix: 'Mr',
    suffixTitle: 'Mr',
  },
  {
    suffixId: '5',
    suffix: 'Mrs',
    suffixTitle: 'Mrs',
  },
  {
    suffixId: '6',
    suffix: 'Ms',
    suffixTitle: 'Ms',
  },
  {
    suffixId: '7',
    suffix: 'Rev',
    suffixTitle: 'Rev',
  },
];
